import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DwSecurityUserService } from '@devwareapps/devware-cap';
import { RoEthosUserEntity } from '../../meta-data/performancemanagement-meta-data.service';
import { EmployeeReviewAnalysis, SkillAverage } from '../../services/performance-management-review.service';
import { AppPermissions } from '../../../../meta-data/app-permissions.enum';

@Component({
  selector: 'app-employee-review-chart',
  templateUrl: './employee-review-chart.component.html',
  styleUrls: ['./employee-review-chart.component.scss'],
  encapsulation : ViewEncapsulation.None
})
export class EmployeeReviewChartComponent implements OnInit {

  @Input() employeeReviewAnalysis: EmployeeReviewAnalysis;
  @Input() employeeUser: RoEthosUserEntity;
  @Input() supervisorUser: RoEthosUserEntity;

  showScoreDetails: boolean = false;

  graphImageUrl: string = '/assets/wachter/images/performance-management-graph.png';

  // maxWidth = 484;
  // maxHeight = 414;

  maxWidth = 364;
  maxHeight = 307;

  maxValue = 3;
  minValue = 0;

  minBubbleSize = 0;
  maxBubbleSize = 1.5;

  // minBubblePixels = 40;
  // maxBubblePixels = 140;
  
   minBubblePixels = 65;
   maxBubblePixels = 105; 
  
  employeeScoreStlye: any = {};
  supervisorScoreStlye: any = {};

  constructor(private dwSecurityUserService: DwSecurityUserService) {
      const urlPrefix = window.location.origin;

      this.graphImageUrl = `${urlPrefix}/assets/wachter/images/performance-management-graph.png`;
  }

  ngOnInit(): void {
      this.showScoreDetails = this.dwSecurityUserService.hasPermission(AppPermissions.performanceManagementCanViewAll, false);

      // this.employeeReviewAnalysis.employeeSkillAverage.bubbleSize=3;
      // this.employeeReviewAnalysis.employeeSkillAverage.hardSkillAverage=2;
      // this.employeeReviewAnalysis.employeeSkillAverage.softSkillAverage=2;

      // this.employeeReviewAnalysis.supervisorSkillAverage.bubbleSize=55;
      // this.employeeReviewAnalysis.supervisorSkillAverage.hardSkillAverage=3;
      // this.employeeReviewAnalysis.supervisorSkillAverage.softSkillAverage=3;

      this.employeeScoreStlye = this.createBubbleStyle(this.employeeReviewAnalysis.employeeSkillAverage);
      this.supervisorScoreStlye = this.createBubbleStyle(this.employeeReviewAnalysis.supervisorSkillAverage);

      // Log this out for admins only
      if (this.showScoreDetails){
        console.log('Employee Review Analysis', this.employeeReviewAnalysis);
      }
  }

  createBubbleStyle(skillAverage: SkillAverage): any {
     const bubblePrixelSize = this.calculateBubblePixelSize(skillAverage.bubbleSize);
 
     const maxRange = this.maxValue - this.minValue;

      const widthFactor = this.maxWidth / maxRange;
      const heightFactor = this.maxHeight / maxRange;

      let softAverage = skillAverage.softSkillAverage - 1;
      let hardAverage = skillAverage.hardSkillAverage - 1;

      if (softAverage < this.minValue) {
        softAverage = this.minValue;
      }

      if (hardAverage < this.minValue) {
        hardAverage = this.minValue;
      }

      const top = (this.maxValue - hardAverage) * heightFactor - bubblePrixelSize/2;
      const left = softAverage * widthFactor - bubblePrixelSize/2;

      return {
        'position': 'absolute',
        'width': `${bubblePrixelSize}px`,
        'height': `${bubblePrixelSize}px`,
        'top': `${top}px`,
        'left': `${left}px`,
      };
  }

  private calculateBubblePixelSize(bubbleSize: number):number {

    if (bubbleSize < this.minBubbleSize) bubbleSize = this.minBubbleSize;
    if (bubbleSize > this.maxBubbleSize) bubbleSize = this.maxBubbleSize;

    // Determine the percent size
    const sizePercent = (bubbleSize - this.minBubbleSize) / (this.maxBubbleSize - this.minBubbleSize);

    const pixelSize = ((this.maxBubblePixels - this.minBubblePixels) * sizePercent) + this.minBubblePixels;

    return pixelSize;
  }

}
